<p>hero-ingredient-view works!</p>
